// import React from "react";

// export default function Obd() {
//   const chnageColor = (colorChange) => {
//     const element = document.getElementById("getid");
//     element.style.color = colorChange;
//   };

//   const querySelector = () => {
//     document.querySelector("p").style.backgroundColor = "blue";
//   };

//   return (
//     <div className="container-fluid">
//       <div className="" id="getid">
//         <p>Hello This is me </p>
//       </div>
//       <button onClick={() => chnageColor("blue")}>Blue</button>
//       <button onClick={() => querySelector()}>Red</button>
//     </div>
//   );
// }

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { common_axios } from "../../App";

// export default function Obd() {
//   const [res, setRes] = useState({
//     // posts: [],
//     // comments: [],
//     // albums: [],
//   });

//   const roles = 3;
//   const getusers = async () => {
//     // setRes(res.data);

//     // let enabledArray = [];
//     // for (let index = 0; index < res?.data?.length; index++) {
//     //   const element = res?.data?.[index];
//     //   if (element.id > 14 && element.id < 21) {
//     //     enabledArray.push(element);
//     //   }
//     // }

//     // console.log({ enabledArray });

//     // setRes(enabledArray);

//     const res1 = await common_axios(
//       "https://jsonplaceholder.typicode.com/posts"
//     );
//     const res2 = await common_axios(
//       "https://jsonplaceholder.typicode.com/comments"
//     );
//     const res3 = await common_axios(
//       "https://jsonplaceholder.typicode.com/albums"
//     );

//     axios
//       .all([res1, res2, res3])
//       .then(
//         axios.spread((...responses) => {
//           setRes({
//             ...res,
//             posts: responses[0].data,
//             Prettier: responses[1].data,
//             prett: responses[2].data,
//           });

//           // const res2 = setRes({ ...res, Prettier: responses[1].data });
//           // const res3 = setRes({ ...res, prett: responses[2].data });
//           console.log("shjk");

//           console.log({ res1 });
//         })
//       )
//       .catch((errors) => {
//         console.log(errors);
//       });
//   };
//   console.log({ res });
//   console.log(res.posts);
//   console.log(res.Prettier);
//   console.log(res.prett);

//   let userArray = [];

//   for (let index = 0; index < res?.posts?.length; index++) {
//     const element = res?.posts?.[index];

//     element.userId = roles;
//     if (element.id > 14 && element.id < 21) {
//       if (element.id == 17) {
//         userArray.push(element);
//         // if (element.userId == 1) {

//         // }
//       }
//     }
//   }
//   console.log({ userArray });

//   useEffect(() => {
//     getusers();
//   }, []);

// import moment from "moment";
// import React from "react";

// const functiosss = () => {
//   document.getElementById("birthday").max = new Date(
//     new Date().getTime() - new Date().getTimezoneOffset() * 60000
//   )
//     .toISOString()
//     .split("T")[0];
// };

// export default function Obd() {
//   return (
//     <div className="container-fluid">
//       <input
//         type="date"
//         id="birthday"
//         name="birthday"
//         // min="2012-12-25"
//         // max={new Date()}
//         min={moment(new Date()).format("YYYY-MM-DD")}
//       />
//     </div>
//   );
// }

// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import Modal from "@mui/material/Modal";

// import { ImageList, ImageListItem } from "@mui/material";
// import { el } from "date-fns/locale";
// import React, { useEffect, useState } from "react";
// import { useLocation, useParams } from "react-router-dom";
// import { common_axios } from "../../App";

// export default function Obd() {
//   const lcoation = useLocation();
//   const { id } = useParams();
//   const [obdData, setobdData] = useState([]);
//   const filteredData = async () => {
//     const res = await common_axios("https://dummyjson.com/products");

//     setobdData({
//       ...obdData,
//       data: res?.data?.products,
//     });
//     const ids = res?.data?.products?.map((o) => o.title);
//     const idsPhotos = res?.data?.products?.map((o) => o.images);

//     setobdData({
//       ...obdData,
//       ideas: idsPhotos,
//       idea: ids,
//     });
//   };
//   const style = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "auto",
//     bgcolor: "background.paper",
//     border: "2px solid #000",
//     boxShadow: 24,
//     p: 4,
//   };
//   const [open, setOpen] = React.useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);
//   const [Image, setImage] = useState("");

//   const openModal = (e) => {
//     console.log(e);
//     setImage(e);
//     setOpen(true);
//   };
//   console.log("arrrrraayy", Image);

//   useEffect(() => {
//     filteredData();
//   }, []);

//   // for (let index = 0; index < obdData.length; index++) {
//   //   const element = obdData[index];
//   //   // console.log({ element });
//   //   if (element.id > 10 && element.id < 21) {
//   //     data.push(element);

//   //   }

//   // }

//   // useEffect(() => {
//   //   if (obdData?.options != undefined) {
//   //     const data1 = obdData?.data?.filter((el) => {
//   //       return obdData?.options == el.userId;
//   //     });

//   //     setobdData({
//   //       ...obdData,
//   //       filtereddata: data1,
//   //     });
//   //   }
//   // }, [obdData?.options]);

//   // console.log(obdData.filteredData);

//   return (
//     <>
//       {/* <Button onClick={handleOpen}>Open modal</Button> */}
//       <Modal
//         className="w-100"
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box sx={style}>
//           <Typography id="modal-modal-title" variant="h6" component="h2">
//             Information
//           </Typography>
//           <Typography
//             full
//             className="w-100"
//             id="modal-modal-description"
//             sx={{ mt: 2 }}
//           >
//             {Image != "" ? (
//               <>
//                 {" "}
//                 <img src={Image} alt="" />
//               </>
//             ) : (
//               <>Loading....</>
//             )}
//           </Typography>
//         </Box>
//       </Modal>
//       {/* <h1> */} this is nikhil testing
//       <ImageList sx={{ width: 1500, height: 850 }} cols={5} rowHeight={264}>
//         {obdData?.ideas?.map((e, index) => {
//           console.log(e);
//           return (
//             <>
//               {e.map((item, index) => (
//                 <ImageListItem key={index}>
//                   <img
//                     src={`${item}?w=164&h=164&fit=crop&auto=format`}
//                     srcSet={`${item}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
//                     // alt={item.title}
//                     onClick={() => {
//                       openModal(item);
//                     }}
//                     loading="lazy"
//                   />
//                 </ImageListItem>
//               ))}
//               {/* {e.map((el, index) => {
//               console.log(el);
//               return (
//                 <>
//                 <img src={el} key={index} />
//                 </>
//               );
//             })} */}
//             </>
//           );
//         })}
//       </ImageList>
//       {/* </h1> */}
//       {/* {obdData?.ideas?.map((e) => {
//         return <>{e[0]}</>;
//       })} */}
//     </>
//   );
// }

import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { useState } from "react";
import axios from "axios";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Obd() {
  const [variantName, setVariantName] = useState([]);
  const [variants, setVariants] = useState([]);
  const documentsupload = async () => {
    try {
      const res = await axios(`https://dummyjson.com/quotes`);
      console.log(res.data);
      setVariants(res.data.quotes);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    documentsupload();
  }, []);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    let duplicateRemoved = [];

    value.forEach((item) => {
      console.log(item);
      if (duplicateRemoved.findIndex((o) => o.id === item) >= 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x === item);
      } else {
        duplicateRemoved.push(item);
      }
    });

    setVariantName(duplicateRemoved);
  };

  console.log({ variantName });

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label">Tag</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={variantName}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" />}
          // renderValue={(selected) => selected.map((x) => x).join(", ")}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
        >
          {variants.map((name) => {
            console.log({ name });
            return (
              <MenuItem key={name.id} value={name.id}>
                <Checkbox checked={variantName.indexOf(name.id) > -1} />
                <ListItemText primary={name.author} />
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
}
